export const fetchCart = `
  query FetchCart($shopifyCartId: ID!) {
    node(id: $shopifyCartId) {
      ... on Cart {
          id
          lines(first:100) {
            edges {
              node {
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    product {
                      id
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;
export const cartCreate = `
  mutation CartCreate($input: CartInput!) {
    cartCreate(
      input: $input
    ) {
      cart {
        id
        checkoutUrl
      }
      userErrors {
        field
        message
      }
    }
  }`;
export const getCustomer = `
  query GetCustomer($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      id
      email
      defaultAddress {
        address1
        address2
        city
        provinceCode
        countryCode
        zip
        firstName
        lastName
        phone
        company
      }
    }
  }`;
export const shopifyLogin = `
  mutation ShopifyLogin($email: String!, $password: String!) {
    customerAccessTokenCreate(input: {
          email: $email
          password: $password
        }) {
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            code
            field
            message
          }
        }
    }`;
export const renewCustomerToken = `
  mutation RenewCustomerToken($customerAccessToken: String!) {
    customerAccessTokenRenew(customerAccessToken: $customerAccessToken) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        userErrors {
          field
          message
        }
      }
  }`;
export const deleteCustomerToken = `
  mutation DeleteCustomerToken($customerAccessToken: String!) {
    customerAccessTokenDelete(customerAccessToken: $customerAccessToken) {
        deletedAccessToken
        deletedCustomerAccessTokenId
        userErrors {
          field
          message
        }
      }
  }`;
